import React, { createContext, useContext, useMemo, useState } from 'react';

export interface HoverInfo {
  courseId: string;
  courseCardPosition: DOMRect;
}

interface HoverInfoContext {
  hoverInfo: HoverInfo | null;
  setHoverInfo: (data: HoverInfo | null) => void;
}

interface SidebarProviderProps {
  children: React.ReactNode;
}

const SidebarContext = createContext<HoverInfoContext | undefined>(undefined);

export const useSidebarContext = (): HoverInfoContext => {
  const context = useContext(SidebarContext);

  if (!context) {
    throw new Error('useSidebarContext must be used within a SidebarContextProvider');
  }

  return context;
};

export const SidebarProvider: React.FC<SidebarProviderProps> = ({ children }) => {
  const [hoverInfo, setHoverInfo] = useState<HoverInfo | null>(null);

  const contextValue = useMemo(() => ({ hoverInfo, setHoverInfo }), [hoverInfo, setHoverInfo]);

  return <SidebarContext.Provider value={contextValue}>{children}</SidebarContext.Provider>;
};
